import { render, staticRenderFns } from "./clickXT.vue?vue&type=template&id=6def3a94&scoped=true"
import script from "./clickXT.vue?vue&type=script&lang=js"
export * from "./clickXT.vue?vue&type=script&lang=js"
import style0 from "./clickXT.vue?vue&type=style&index=0&id=6def3a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def3a94",
  null
  
)

export default component.exports